// extracted by mini-css-extract-plugin
module.exports = {"builder":"Layout_builder__2kePy","buttonsGroup":"Layout_buttonsGroup__2mcCF"};